import { render, staticRenderFns } from "./CompanyListCard.vue?vue&type=template&id=74ad6fd2"
import script from "./CompanyListCard.vue?vue&type=script&lang=js"
export * from "./CompanyListCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyListCard.vue?vue&type=style&index=0&id=74ad6fd2&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports